import AuthDataConfForm from "./AuthDataConfForm";

export default AuthDataConfForm;
